import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig as defaultMsalConfig } from "./pages/auth/login/authConfig";
import { BrowserRouter } from "react-router-dom";
import { createMemoryHistory } from "history";
import { store } from "./store";
import { Provider } from "react-redux";
import "react-quill/dist/quill.snow.css";
import { API_CALL_URL_PUBLIC } from "./constants/compensate";
import axios from "./axios";
import { ssodecrypted } from "./utils/helper";

const fetchAzureConfig = async () => {
  try {
    const response = await axios.post(`${API_CALL_URL_PUBLIC}/public/abc0199`);
    const responseData = ssodecrypted(response?.data?.responseData);
    return {
      tenantId: responseData?.data?.tenant_id,
      clientId: responseData?.data?.client_id
    };
  } catch (error) {
    console.error('Error fetching Azure config:', error);
    return {
      tenantId: defaultMsalConfig.auth.tenantId,
      clientId: defaultMsalConfig.auth.clientId
    };
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
const history = createMemoryHistory();


const initializeApp = async () => {
  const azureConfig = await fetchAzureConfig();

  const tenantId = azureConfig?.tenantId;
  const clientId = azureConfig?.clientId;

  const msalConfig = {
    ...defaultMsalConfig,
    auth: {
      ...defaultMsalConfig.auth,
      tenantId,
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
    },
  };

  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();


root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      {/* <SocketContext.Provider value={socket}> */}
      <Provider store={store}>
        <BrowserRouter location={history.location} navigator={history}>
          <App />
        </BrowserRouter>
      </Provider>
      {/* </SocketContext.Provider> */}
    </MsalProvider>
  </React.StrictMode>
);
};

initializeApp();
reportWebVitals();
